import Vue from 'vue';

const state = {
};

const getters = {
	'auth/section': () => (item) => {
		let pass = false;

		if (item.auth) {
			pass = Vue.prototype.$gestios.auth.check({
				scopes: item.auth.roles,
				strict: item.auth.strict
			});
		} else {
			pass = true;
		}

		return pass;
	}
};

const mutations = {

};

const actions = {

};

export default {
	state,
	getters,
	actions,
	mutations
};
